import {
  SET_USER,
  SET_SPORTS,
  SET_PACKAGES,
  SET_CATS,
  SET_PICKS,
  SET_EDIT_USER,
  SET_ODDS,
  SET_SPORT,
  SET_CURRENT_PACKAGE,
  SET_PRODUCTS,
  SET_CURRENT_PRODUCT,
  ADD_TO_CART,
  UPDATE_CART_ITEM,
  REMOVE_FROM_CART,
  CLEAR_CART,
} from "./mutation-types";
import _ from "lodash";

export default {
  [SET_USER](state, user) {
    state.currentUser = user;
    state.isAuthenticated = !_.isUndefined(state.currentUser);
  },
  [SET_SPORTS](state, sports) {
    state.sports = sports;
  },
  [SET_PACKAGES](state, packages) {
    state.packages = packages;
  },
  [SET_CATS](state, cats) {
    state.categories = cats;
  },
  [SET_PICKS](state, picks) {
    state.picks = picks;
  },
  [SET_EDIT_USER](state, user) {
    state.editUser = user;
  },
  [SET_ODDS](state, data) {
    const sport = state.selectedSport;
    console.log(data.data);
    const sp = _.assignIn({}, state.odds[sport], state.odds[sport], data.data);
    state.odds = _.assignIn({}, state.odds, { [sport]: sp });
    console.log(state.odds["mlb"]);
  },
  [SET_SPORT](state, data) {
    state.sport = data;
  },
  [SET_CURRENT_PACKAGE](state, p) {
    state.currentPackage = p;
  },
  // Shop mutations
  [SET_PRODUCTS](state, products) {
    state.products = products;
  },
  [SET_CURRENT_PRODUCT](state, product) {
    state.currentProduct = product;
  },
  [ADD_TO_CART](state, item) {
    const existingItem = state.cart.find((i) => i.variantId === item.variantId);
    if (existingItem) {
      existingItem.quantity += item.quantity;
    } else {
      state.cart.push(item);
    }
    localStorage.setItem("sts_cart", JSON.stringify(state.cart));
  },
  [UPDATE_CART_ITEM](state, { variantId, quantity }) {
    const item = state.cart.find((i) => i.variantId === variantId);
    if (item) {
      item.quantity = quantity;
    }
    localStorage.setItem("sts_cart", JSON.stringify(state.cart));
  },
  [REMOVE_FROM_CART](state, variantId) {
    state.cart = state.cart.filter((i) => i.variantId !== variantId);
    localStorage.setItem("sts_cart", JSON.stringify(state.cart));
  },
  [CLEAR_CART](state) {
    state.cart = [];
    localStorage.removeItem("sts_cart");
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js